export enum Status {
    idle,
    loading,
    success,
    failed,
}
